/* import __COLOCATED_TEMPLATE__ from './name.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Component from '@glimmer/component';

export default class Name extends Component {
  get locale() {
    return this.args.translationSettings?.possibleLocales.findBy(
      'localeId',
      this.args.translation.locale,
    );
  }
}
